import React from "react";
import { connect } from "react-redux";
import {
  postClientUserDetails,
  getClientManagementList,
  getSpecialClientUsersManagementList,
  getShipnameListByCompanyName,
} from "../Actions/ClientManagementAPI";
import { Multiselect } from "multiselect-react-dropdown";
import "react-datepicker/dist/react-datepicker.css";
import AddIcon from "../UIComponents/AddIcon";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import Autocomplete from "react-autocomplete";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import {
  getCompanynameList,
  getCompanySpecialList,
} from "../Actions/HelpersAPI";
import { confirmAlert } from "react-confirm-alert";
// const Clientlist = {
//   companyName: "",
//   email: "",
//   phone: "",
//   address: "",
//   createdBy: "",
// }
let user = JSON.parse(localStorage.getItem("currentUser"));

let NewRole = "specialaccess";
class SpecialAccessManagementAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ClientInfo: {
        companyName: "",
        clientId: 0,
        email: "",
        phone: "",
        address: "",
        createdBy: "",
        name: "",
        isTeFromApplicable: false,
      },
      vesselModal: false,
      clientData: [],
      ships: [],
      FleetManager: {
        clientId: 0,
      },
      TechSuperintendent: {
        clientId: 0,
        createdBy: "",
      },
      TechExecutive: {
        clientId: 0,
        createdBy: "",
      },
      owner: false,
      management: false,
      currentClientId: 0,
      isEdit: false,
      tempShips: null,
      vesselError: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SubmitData = this.SubmitData.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: "SubBannerTitle",
      data: "Special Access Management",
    });
    dispatch(getCompanySpecialList());
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { fleetManagerlist, TechExecutivelist, TechSuperintendentlist } =
      nextProps;
    if (fleetManagerlist) {
      prevState.FleetManager = fleetManagerlist;
    }
    if (TechSuperintendentlist) {
      prevState.TechSuperintendent = TechSuperintendentlist;
    }
    if (TechExecutivelist) {
      prevState.TechExecutive = TechExecutivelist;
    }
    // if (clientId && clientId !== "") {
    //   prevState.FleetManager.clientId = clientId;
    //   prevState.TechSuperintendent.clientId = clientId;
    //   prevState.TechExecutive.clientId = clientId;
    //   let users = [prevState.FleetManager, prevState.TechSuperintendent, prevState.TechExecutive];
    //   console.log("users", users);
    // }
  }

  async SubmitData() {
    const { dispatch } = this.props;
    let searchData = {
      Name: "",
      Company: "",
      PageNumber: 1,
      PageSize: 25,
    };
    console.log("jk", user);
    const { name, email, companyName, clientId, phone } = this.state.ClientInfo;
    let warning = [];
    if (name === "") {
      warning.push("Name");
    }
    if (this.state.clientData.length == 0) {
      warning.push("Client");
    }
    if (email === "") {
      warning.push("Email");
    }
    if (name !== "" && email !== "" && this.state.clientData.length !== 0) {
      let url2 = `${API.userExist}?Mail=${
        this.state.ClientInfo.email
      }&Id=${0}&Role=${NewRole}`;
      axios
        .get(url2, {
          headers: {
            key: user.accessToken,
          },
        })
        .then(async (response) => {
          if (response.data === true) {
            let url = `${API.PostSpecialAccess}`;
            let userData = [
              {
                name: name,
                role: "SpecialAccess",
                email: email,
                address: "",
                phone: phone,
                createdBy: user?.name ?? "",
                clients:this.state.clientData
              },
            ];
            // let urlclient = `${API.ClientUser}`;
            axios
              .post(API.PostSpecialAccess, userData, {
                headers: {
                  key: user.accessToken,
                },
              })
              .then((response) => {
                toast.success("Added Successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });

                dispatch(getSpecialClientUsersManagementList(searchData));
                this.props.history.push("/Home/Management/SpecialAccess");
                dispatch({
                  type: "postClientUserDetailsSuccess",
                  data: response.data,
                });
              })

              .catch((error) => {
                dispatch({
                  type: "postClientUserDetailsFailure",
                  error: "ERROR",
                });
              });
            // dispatch(postClientUserDetails(userData));
            // const res1 = await dispatch(
            //   getSpecialClientUsersManagementList(searchData)
            // );

            // axios
            //   .post(url, userData, {
            //     headers: {
            //       key: user.accessToken,
            //     },
            //   })
            //   .then((response) => {
            //     debugger;
            //     let clientUsers = [];
            //     // console.log("clientUsers", clientUsers);
            //     if (clientUsers.length != 0) {
            //       dispatch(postClientUserDetails(clientUsers));
            //     }
            //     dispatch(getClientManagementList(searchData));
            //     this.props.history.push("/Home/Management/Client");
            //     dispatch({
            //       type: "postClientDetailsSuccess",
            //       data: response.data,
            //     });
            //   })
            //   .catch((error) => {
            //     dispatch({
            //       type: "postClientDetailsFailure",
            //       error: "ERROR",
            //     });
            //   });
          } else if (response.data === false) {
            swal(
              "Error!",
              "User already exist. Please change the email",
              "warning"
            );
            this.state.ClientInfo.email = "";
            this.setState({});
          }
          dispatch({
            type: "getUserExistListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getUserExistListFailure",
            data: "error",
          });
        });
    } else {
      // let warningMsg = "";
      // warning.map((i, index) => {
      //   if (warning.length === 1) {
      //     warningMsg = i;
      //   } else if (warning.length - 1 === index) {
      //     warningMsg = warningMsg + " and " + i;
      //   } else {
      //     warningMsg = warningMsg + "," + i;
      //   }
      // });
      // swal("Error!", warningMsg + " is mandatory", "warning");
      let warningMsg = "";

      if (warning.length === 1) {
        warningMsg = warning[0];
      } else if (warning.length === 2) {
        warningMsg = warning.join(" and ");
      } else if (warning.length > 2) {
        warningMsg =
          warning.slice(0, -1).join(", ") +
          " and " +
          warning[warning.length - 1];
      }

      swal("Error!", `${warningMsg} is mandatory`, "warning");
    }
    //  else if (companyName == "" && ) {
    //   swal("Error!", "Name is mandatory", "warning");
    // } else {
    //   swal("Error!", "Email is mandatory", "warning");
    // }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.ClientInfo[nodeName] = e.target.value;
    this.setState({});
  }

  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.state.ClientInfo.isTeFromApplicable = true;
      this.setState({});
    } else {
      this.state.ClientInfo.isTeFromApplicable = false;
      this.setState({});
    }
  }

  renderCompanyTitle = (state, val) => {
    return state?.name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  };
  handleInputChanges(e) {
    this.state.ships = [];
    this.state.ClientInfo.companyName = e.target.value;
    // if (e.target.value == "") {
    //   this.props.dispatch(getShipnameListByCompanyName(0));
    // } else {
    //   this.props.dispatch({
    //     type: "getshipByCompanySuccess",
    //     data: [],
    //   });
    // }
    this.setState({});
  }
  // handleSelectChange(value, item) {
  //   const { dispatch } = this.props;
  //   this.state.ships = [];
  //   this.state.ClientInfo.companyName = value;
  //   this.state.ClientInfo.clientId = item.id;
  //   dispatch(getShipnameListByCompanyName(item.id));
  //   this.setState({});
  // }
  handleSelectChange(value, item) {
    const { dispatch } = this.props;
    this.state.ships = [];
    // this.state.ClientInfo.companyName = value;
    // this.state.ClientInfo.clientId = item.id;
    let url = `${API.shipNames}?clientId=${item.id}`;
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getshipByCompanySuccess",
          data: response.data.ships,
        });
        if (response.data.ships.length > 0) {
          this.handleAddClient(value, item);
        } else {
          this.state.ClientInfo.companyName = "";
          this.setState({});
          swal(
            "Warning!",
            "No ships have been assigned to this client",
            "warning"
          );
        }
      })
      .catch((error) => {
        dispatch({
          type: "getshipByCompanyFailure",
          error: "ERROR",
        });
      });

    // dispatch(getShipnameListByCompanyName(item.id)).then((res) => {
    //   debugger;
    //   if (res.data.ships.length > 0) {
    //     this.handleAddClient(value, item);
    //   } else {
    //     swal("Error!", "No ships have been assigned to this client", "warning");
    //   }
    // });
    this.setState({});
  }

  handleClientEdit = (id) => {
    const { dispatch } = this.props;
    if (id) {
      let url = `${API.shipNames}?clientId=${id}`;
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "getshipByCompanySuccess",
            data: response.data.ships,
          });
          if (response.data.ships.length > 0) {
            this.setState({
              currentClientId: id,
              vesselModal: true,
              isEdit: true,
              vesselError: false,
            });
            this.AddtempShips(id);
          } else {
            this.state.ClientInfo.companyName = "";
            this.setState({});
          }
        })
        .catch((error) => {
          dispatch({
            type: "getshipByCompanyFailure",
            error: "ERROR",
          });
        });
    }
  };

  AddtempShips = (id) => {
    let client = this.state.clientData.find((c) => c.clientId === id) || null;
    const currentShips = client
      ? JSON.parse(JSON.stringify(client.shipNames)) // ✅ Deep copy
      : [];
    this.setState({ tempShips: currentShips });
  };
  AddClientdata = () => {
    let currentShips =
      this.state.clientData.find(
        (c) => c.clientId === this.state.currentClientId
      )?.shipNames || [];
    if (currentShips.length > 0) {
      this.state.ClientInfo.companyName = "";
      this.setState({
        vesselModal: false,
        currentClientId: 0,
        isEdit: false,
        vesselError: false,
      });
    } else {
      this.setState({ vesselError: true });
    }
  };

  closeClientData = () => {
    const { clientData, currentClientId } = this.state;
    let currentShips =
      this.state.clientData.find(
        (c) => c.clientId === this.state.currentClientId
      ) || null;
    if (this.state.isEdit) {
      const { clientData, tempShips, currentClientId } = this.state;

      // Create a deep copy of clientData to avoid direct mutations
      const updatedClientData = clientData.map((client) =>
        client.clientId === currentClientId
          ? {
              ...client,
              shipNames: JSON.parse(JSON.stringify(tempShips)),
            }
          : client
      );
      this.state.ClientInfo.companyName = "";

      this.setState({
        clientData: updatedClientData,
        currentClientId: 0,
        tempShips: null,
        isEdit: false,
        vesselModal: false,
      });
    } else {
      if (currentShips) {
        this.state.ClientInfo.companyName = "";
        this.setState({
          clientData: clientData.filter((c) => c.clientId !== currentClientId),
          vesselModal: false,
          currentClientId: 0,
          isEdit: false,
        });
      }
    }
  };
  DeletePopup(id) {
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.handledeleteClient(id);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  handledeleteClient = (id) => {
    const { clientData } = this.state;
    this.setState({
      clientData: clientData.filter((c) => c.clientId !== id),
    });
  };

  handleAddClient = (value, item) => {
    let newClient = {
      clientName: value,
      clientId: item.id,
      shipNames: [],
    };

    this.setState(
      (prevState) => ({
        clientData: [...prevState.clientData, newClient],
        currentClientId: item.id,
        vesselModal: true,
        vesselError: false,
      }),
      () => {
        console.log(this.state.clientData);
      }
    );
  };
  // onSelectChange(item) {
  //   this.state.ships = item;
  //   this.setState({});
  //   console.log(this.state.ships);
  // }
  // onRemoveChange(item) {
  //   this.state.ships = item;
  //   this.setState({});
  // }

  onSelectChange = (selectedShips) => {
    this.setState((prevState) => ({
      clientData: prevState.clientData.map((client) =>
        client.clientId === this.state.currentClientId
          ? { ...client, shipNames: selectedShips } // ✅ update ships for matched client
          : client
      ),
    }));
  };

  onRemoveChange = (updatedShips) => {
    this.setState((prevState) => ({
      clientData: prevState.clientData.map((client) =>
        client.clientId === this.state.currentClientId
          ? { ...client, shipNames: updatedShips } // ✅ same logic, remove or modify
          : client
      ),
    }));
  };

  render() {
    const {
      showSidePane,
      fleetManagerlist,
      TechSuperintendentlist,
      TechExecutivelist,
      CompanyNames,
      ShipNameList,
    } = this.props;
    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="row search-filter-box">
                <div className="col-lg-12">
                  <div
                    className="card mt-2 MM-card-header mb-0"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Basic Information
                      </h5>
                    </div>
                  </div>
                  <div className="row search-filter-box pb-4">
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        placeholder="Name"
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.ClientInfo.name}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Email</label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Email"
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.ClientInfo.email}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Phone </label>
                      <input
                        className="form-control"
                        type="text"
                        name="phone"
                        placeholder="Phone "
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.ClientInfo.phone}
                      ></input>
                    </div>
                  </div>
                  <div
                    className="card mt-2 MM-card-header mb-0"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Applicable Clients
                      </h5>
                    </div>
                  </div>
                  <div className="row search-filter-box pb-4">
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      {/* <label className="form-label">Address</label> */}
                      <div className="autocomplete-wrappers">
                        <label className="form-label">Client Name</label>
                        <br></br>
                        <Autocomplete
                          value={this.state.ClientInfo.companyName ?? ""}
                          // items={CompanyNames ?? []}
                          items={(CompanyNames ?? []).filter(
                            (c) =>
                              !this.state.clientData.some(
                                (client) => client.clientId === c.id
                              )
                          )}
                          getItemValue={(item) => item?.name}
                          renderInput={(props) => {
                            return (
                              <input
                                className="form-control"
                                id="exampleFormControlInput1"
                                placeholder="Client Name"
                                {...props}
                              />
                            );
                          }}
                          shouldItemRender={this.renderCompanyTitle.bind(this)}
                          renderMenu={(item) => (
                            <div className="dropdowns">{item}</div>
                          )}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={`items ${
                                isHighlighted ? "selected-items" : ""
                              }`}
                            >
                              {item.name}
                            </div>
                          )}
                          onChange={(e, field) => this.handleInputChanges(e)}
                          onSelect={(value, item) =>
                            this.handleSelectChange(value, item)
                          }
                        />
                      </div>
                    </div>
                    {/* <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Vessel</label>
                      <br></br>
                      <Multiselect
                        selectedValues={this.state.ships}
                        emptyRecordMsg={""}
                        options={ShipNameList}
                        isObject={false}
                        style={{
                          option: {
                            "margin-right": 0,
                            display: "block",
                            "font-weight": "normal",
                          },
                          chips: { "background-color": "#1E3A8A" },
                        }}
                        onSelect={(item) => this.onSelectChange(item)}
                        onRemove={(item) => this.onRemoveChange(item)}
                        placeholder={
                          this.state.ships && this.state.ships.length
                            ? ""
                            : "Select"
                        }
                        closeIcon="cancel"
                      />
                    </div> */}
                    <div className="col-12 mt-3">
                      {this.state.clientData.map((data) => (
                        <div
                          className="card MM-card-content click p-0"
                          style={{
                            backgroundColor: "#f0f0f0",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <div className="px-3 py-2">
                            <div className="resource-list-auth-date">
                              <div className="row">
                                <div className="col-lg-8 col-sm-12 d-flex align-items-center">
                                  <div className="row">
                                    <div className="col-sm-12 py-1 d-flex align-items-center">
                                      <span>
                                        <strong>Client Name : </strong>{" "}
                                        {data.clientName}{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-2 ">
                                  <div className="d-flex justify-content-end align-items-center">
                                    <i
                                      className="fa fa-edit fa-2x fa-lg click p-2 mt-2"
                                      aria-hidden="true"
                                      style={{ color: " #1E3A8A" }}
                                      onClick={() => {
                                        this.handleClientEdit(data.clientId);
                                      }}
                                    ></i>
                                    <i
                                      className="fa fa-trash fa-2x click p-2"
                                      aria-hidden="true"
                                      onClick={() => {
                                        this.DeletePopup(data.clientId);
                                      }}
                                      style={{ color: " #1E3A8A" }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 py-2">
                      <div
                        className="mb-1 search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.SubmitData()}
                        >
                          Submit
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.moveClientList()}
                        >
                          {" "}
                          Cancel{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          size="lg"
          show={this.state.vesselModal}
          onHide={() => this.setState({ vesselModal: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header>
            <Modal.Title id="example-modal-sizes-title-sm">Vessel</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                {/* <label className="form-label mt-0">Vessel</label>
                <br></br> */}
                <Multiselect
                  selectedValues={
                    this.state.clientData.find(
                      (c) => c.clientId === this.state.currentClientId
                    )?.shipNames || []
                  }
                  // selectedValues={this.state.ships}
                  emptyRecordMsg={""}
                  options={ShipNameList}
                  isObject={false}
                  style={{
                    option: {
                      "margin-right": 0,
                      display: "block",
                      "font-weight": "normal",
                    },
                    chips: { "background-color": "#1E3A8A" },
                  }}
                  onSelect={(item) => this.onSelectChange(item)}
                  onRemove={(item) => this.onRemoveChange(item)}
                  placeholder={
                    this.state.clientData.find(
                      (c) => c.clientId === this.state.currentClientId
                    )?.shipNames &&
                    this.state.clientData.find(
                      (c) => c.clientId === this.state.currentClientId
                    )?.shipNames.length
                      ? ""
                      : "Select"
                  }
                  closeIcon="cancel"
                />
                {this.state.vesselError && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    Select atleast one vessel
                  </div>
                )}
              </div>
              <div className="col-lg-12 text-right mt-2">
                <button
                  className="btn btn-primary text-uppercase txtside-btn blue mt-2"
                  type="submit"
                  onClick={() => {
                    this.AddClientdata();
                  }}
                >
                  {" "}
                  Add{" "}
                </button>
                <button
                  className="btn btn-light text-uppercase txtside-btn ml-3 mt-2"
                  type="button"
                  onClick={() => {
                    this.closeClientData();
                  }}
                >
                  {" "}
                  Cancel{" "}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  moveClientList = () => {
    this.props.history.push("/Home/Management/SpecialAccess");
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    fleetManagerlist: state.MasterScreenReducer.fleetManagerlist || [],
    TechSuperintendentlist:
      state.MasterScreenReducer.TechSuperintendentlist || [],
    TechExecutivelist: state.MasterScreenReducer.TechExecutivelist || [],
    CompanyNames: state.SpecialAccessReducer.specialCompanyList || [],
    ShipNameList: state.SpecialAccessReducer.ShipnameList || [],
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecialAccessManagementAdd);
